import { render, staticRenderFns } from "./BajasComercialesModalVerDetalle.vue?vue&type=template&id=bdbae640&"
import script from "./BajasComercialesModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./BajasComercialesModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bdbae640', component.options)
    } else {
      api.reload('bdbae640', component.options)
    }
    module.hot.accept("./BajasComercialesModalVerDetalle.vue?vue&type=template&id=bdbae640&", function () {
      api.rerender('bdbae640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasComerciales/BajasComercialesModalVerDetalle.vue"
export default component.exports